import { PeopleCostCentreDto } from "./people-cost-centre.dto";
import { PeopleDepartmentDto } from "./people-department.dto";
import { PeopleJobTitleDto } from "./people-job-title.dto";
import { PeopleMerchantDto } from "./people-merchant.dto";
import { PeopleRosterDto } from "./people-roster.dto";
import { PeopleEmployeeDto } from "./employee/people-employee.dto";
import { PeopleQueryBaseDto } from "./people-query-base.dto";

export class PeopleMerchantGroupDto {
    id: number;
    name: string;

    merchants?: PeopleMerchantDto[];
    costCentres?: PeopleCostCentreDto[];
    jobTitles?: PeopleJobTitleDto[];
    employees?: PeopleEmployeeDto[];
    departments?: PeopleDepartmentDto[];
    rosters?: PeopleRosterDto[];
}

export interface PeopleMerchantGroupQueryDto extends PeopleQueryBaseDto {
    name?: string;
}